<template>
  <page-header-wrapper :is-header="isHeader">
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('动态标题')">
                <a-input v-model="queryParam.dynamicTitle" :placeholder="$t('请输入')" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('动态内容')">
                <a-input v-model="queryParam.dynamicContent" :placeholder="$t('请输入')" allow-clear></a-input>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('状态')">
                <a-select v-model="queryParam.status" :placeholder="$t('请选择')">
                  <a-select-option v-for="item in statusArr" :key="`status-${item.value}`" :value="item.value">{{
                    item.label
                  }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('用户邮箱')">
                <a-input v-model="queryParam.userEmail" :placeholder="$t('请输入')" allow-clear></a-input>
              </a-form-item>
            </a-col>

            <template v-if="advanced">
              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('话题')">
                  <a-select v-model="queryParam.topicId" :placeholder="$t('请选择')">
                    <a-select-option v-for="item in topicList" :key="`topic-${item.id}`" :value="item.id">{{
                      item.title
                    }}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('创建时间')">
                  <cy-range-picker
                    :start.sync="queryParam.createBeginTime"
                    :end.sync="queryParam.createEndTime"
                  ></cy-range-picker>
                </a-form-item>
              </a-col>
            </template>
            <a-col :md="(!advanced && 6) || 24" :sm="24">
              <span
                class="table-page-search-submitButtons"
                :style="(advanced && { float: 'right', overflow: 'hidden' }) || {}"
              >
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{ $t('查询') }}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{ $t('重置') }}</a-button>
                <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? $t('收起') : $t('展开') }}
                  <a-icon :type="advanced ? 'up' : 'down'" />
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['cooking:dynamic:remove']">
          <a-icon type="delete" />{{ $t('删除') }}
        </a-button>
        <!-- <a-button type="primary" @click="handleExport" v-hasPermi="['cooking:dev:export']">
          <a-icon type="download" />{{$t('导出')}}
        </a-button> -->
        <table-setting
          :style="{ float: 'right' }"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList"
        />
      </div>
      <!-- 增加修改 -->
      <create-form v-if="visible" ref="createForm" @refresh="getList" @close="visible = false" />
      <!-- 详情 -->
      <detail-form v-if="detailVisible" ref="detailForm" @refresh="getList" @close="detailVisible = false" />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="consultImgUrl" slot-scope="text, record">
          <div v-viewer>
            <img style="width: 50px; height: 50px" :src="record.consultImgUrl" alt="" srcset="" />
          </div>
        </span>
        <span slot="sfRecommend" slot-scope="text, record">
          {{ record.sfRecommend == 1 ? $t('已推荐') : $t('未推荐') }}
        </span>
        <span slot="activityStatus" slot-scope="text, record">
          {{ record.activityStatus | filterCommon(activityStatusArr, 'label') }}
        </span>
        <span slot="commendFlag" slot-scope="text, record">
          {{ record.commendFlag | filterCommon(commendFlagArr, 'label') }}
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="status" slot-scope="text, record">
          {{ record.status | filterCommon(statusArr, 'label') }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a-dropdown>
            <a class="ant-dropdown-link" @click="(e) => e.preventDefault()">
              <a-divider type="vertical" v-hasPermi="['cooking:dynamic:query']" />
              <a @click="handleDetail(record.id)" v-hasPermi="['cooking:dynamic:query']">
                {{ $t('详情') }}
              </a>
              <a-divider type="vertical" v-hasPermi="['cooking:dynamic:remove']" />
              <a @click="handleDelete(record)" v-hasPermi="['cooking:dynamic:remove']">
                {{ $t('删除') }} </a
              ><a-icon v-if="record.status == 1 || record.status == 2" type="down" /><a-icon
                style="width: 10px"
                v-else
                type=""
              />
            </a>
            <a-menu slot="overlay" v-if="record.status == 1 || record.status == 2">
              <a-menu-item v-if="record.status == 2">
                <template>
                  <a @click="handleZd(record.id)" v-hasPermi="['cooking:dynamic:tj']">
                    {{ record.sfRecommend == 0 ? $t('推荐') : $t('取消推荐') }}
                  </a>
                </template>
              </a-menu-item>
              <a-menu-item v-if="record.status == 1">
                <template>
                  <a @click="handleDetail(record.id)" v-hasPermi="['cooking:dynamic:add']">
                    {{ $t('审核') }}
                  </a>
                </template>
              </a-menu-item>
              <a-menu-item v-if="record.status === 2">
                <a @click="handleOffshelf(record.id)" v-hasPermi="['cooking:dynamic:edit']">
                  {{ $t('下架') }}
                </a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="(total) => `${$t('共')} ${total} ${$t('条')}`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { delObj, fetchList, putTop, putObj } from './api'
import { fetchList as getTopicList } from '@/views/program/cookManage/dynamic/topic-list/api'
import CreateForm from './modules/CreateForm'
import DetailForm from './modules/Detail'
import CyRangePicker from '@/components/CyRangePicker'
import { tableMixin } from '@/store/table-mixin'
import variableMixin from '@/core/mixins'

export default {
  name: 'Type',
  components: {
    CreateForm,
    DetailForm,
    CyRangePicker
  },
  props: {
    isHeader: {
      type: Boolean,
      default: true
    },
    topicId: {
      type: String,
      default: undefined
    },
    bookId: {
      type: String,
      default: undefined
    }
  },
  mixins: [tableMixin, variableMixin],
  data() {
    return {
      detailVisible: false,
      commendFlagArr: [
        { value: 0, label: this.$t('是') },
        { value: 1, label: this.$t('否') }
      ],
      activityStatusArr: [
        { value: 0, label: this.$t('未开始') },
        { value: 1, label: this.$t('进行中') },
        { value: 2, label: this.$t('已结束') },
        { value: 3, label: this.$t('取消') }
      ],
      statusArr: [
        { value: 0, label: this.$t('草稿') },
        { value: 1, label: this.$t('待审核') },
        { value: 2, label: this.$t('已发布') },
        { value: 3, label: this.$t('未通过') },
        { value: 4, label: this.$t('取消审核') }
      ],
      visible: false,
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        pageNum: 1,
        pageSize: 10,
        createBeginTime: undefined,
        createEndTime: undefined,
        dynamicContent: undefined,
        dynamicTitle: undefined,
        status: undefined,
        topicId: undefined,
        bookId: undefined,
        userEmail: undefined
      },
      columns: [
        // { title: 'id', dataIndex: 'id', align: 'center', ellipsis: true },
        { title: this.$t('标题'), dataIndex: 'dynamicTitle', align: 'center', ellipsis: true },
        { title: this.$t('话题'), dataIndex: 'dynamicTopicName', align: 'center', ellipsis: true },
        {
          title: this.$t('状态'),
          dataIndex: 'status',
          align: 'center',
          ellipsis: true,
          scopedSlots: { customRender: 'status' }
        },
        {
          title: this.$t('是否推荐'),
          dataIndex: 'sfRecommend',
          align: 'center',
          ellipsis: true,
          scopedSlots: { customRender: 'sfRecommend' }
        },
        { title: this.$t('发布人'), dataIndex: 'userEmail', align: 'center', ellipsis: true },
        {
          title: this.$t('发布时间'),
          dataIndex: 'publicTime',
          scopedSlots: { customRender: 'publicTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('操作'),
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ],
      topicList: []
    }
  },
  filters: {},
  created() {
    getTopicList({ pageNum: 1, pageSize: 2 ** 31 - 1 }).then((res) => {
      this.topicList = res.data.records
    })
    if (this.topicId) this.queryParam.topicId = this.topicId
    if (this.bookId) this.queryParam.bookId = this.bookId
    this.getList()
  },
  computed: {},
  watch: {},
  methods: {
    // 下架
    handleOffshelf(id) {
      const remark = ''
      this.$confirm({
        title: this.$t('请在下方输入下架内容?'),
        content: (h) => <a-textarea placeholder={this.$t('请输入')} v-model={remark}></a-textarea>,
        centered: true,
        onOk: () => {
          if (!remark) {
            this.$message.error('请输入内容')
            return Promise.reject(Error('请输入'))
          }
          putObj({ id, remark }).then((res) => {
            this.getList()
          })
          // return new Promise((resolve, reject) => {
          //   resolve()
          // })
        },
        onCancel: () => {}
      })
    },
    handleZd(id) {
      putTop({ id }).then((res) => {
        this.getList()
      })
    },
    handleDetail(id) {
      this.detailVisible = true
      this.$nextTick(() => {
        this.$refs.detailForm.init(id)
      })
    },
    handleAdd(id) {
      this.visible = true
      this.$nextTick(() => {
        setTimeout(() => {
          this.$refs.createForm.init(id)
        }, 100)
      })
    },
    /** 查询常见问题分类列表 */
    getList() {
      this.loading = true
      fetchList(this.queryParam).then((response) => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParam = {
        pageNum: 1,
        pageSize: 10,
        createBeginTime: undefined,
        createEndTime: undefined,
        dynamicContent: undefined,
        dynamicTitle: undefined,
        status: undefined,
        topicId: undefined,
        bookId: undefined,
        userEmail: undefined
      }
      if (this.topicId) this.queryParam.topicId = this.topicId
      if (this.bookId) this.queryParam.bookId = this.bookId
      this.handleQuery()
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map((item) => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      var that = this
      const ids = row.id || this.ids
      if (row.id) {
        this.ids.push(row.id)
      }
      this.$confirm({
        title: this.$t('提示'),
        content: this.$t('确认删除所选中数据?'),
        onOk() {
          const data = []
          that.ids.map((id) => data.push({ id: id }))
          delObj(data).then(() => {
            that.onSelectChange([], [])
            that.getList()
            that.$message.success(this.$t('删除成功'), 3)
          })
        },
        onCancel() {
          // 取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport() {
      var that = this
      this.$confirm({
        title: this.$t('是否确认导出?'),
        content: this.$t('此操作将导出当前条件下所有数据而非选中数据'),
        onOk() {
          that.download(
            'problem/type/export',
            {
              ...that.queryParam
            },
            `常见问题分类_${new Date().getTime()}.xls`
          )
        },
        onCancel() {}
      })
    }
  }
}
</script>
